<template>
  <div>
    <h1>Dashboard Inventario</h1>
    <p>Bienvenido al módulo de inventario.</p>
  </div>
</template>

<script>
export default {
  name: 'DashboardInventario'
}
</script>